module.exports = __webpack_public_path__ + "static/media/automate.ae3a8441.svg";